import React, { useState } from 'react'
import Portal from 'components/Portal/Portal'
import Sidebar from 'components/SidebarContent/Sidebar'
import { FacilityFormTemplateProps } from './FacilityFormTemplate.props'
import { FacilityFormTemplateContainer } from './FacilityFormTemplate.styled'

const FacilityFormTemplate = ({ children }: FacilityFormTemplateProps) => {
  const [showSidebar, setShowSidebar] = useState<boolean>(false)
  return (
    <FacilityFormTemplateContainer>
      <Portal id={'sidebar_portal'}>
        <Sidebar
          type={'facility'}
          sidebarOpen={showSidebar}
          toggleSidebar={() => setShowSidebar(!showSidebar)}
        />
      </Portal>
      {children}
    </FacilityFormTemplateContainer>
  )
}

export default FacilityFormTemplate
